import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { Label } from 'reactstrap';

import 'style/layout/Forms.css';

const CreatableDropdown = ({
  value,
  name,
  onChange,
  options,
  placeholder,
  label,
  disabled,
}: {
  value: any;
  name: string;
  onChange: any;
  options: any;
  placeholder: string;
  label: string;
  disabled?: boolean;
}): JSX.Element | null => {
  return (
    <>
      <Label className="label">{label}</Label>
      <CreatableSelect
        className={disabled ? 'creatable-select-disabled' : 'creatable-select'}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={disabled}
      />
    </>
  );
};

export default CreatableDropdown;
